import DatePicker from 'components/date-picker/date-picker';
import React, { FC } from 'react';
import { Control, Controller, FieldPath } from 'react-hook-form';
import { OrderProperty } from 'types/order';

type PropertyDatePickerProps = {
  control: Control<Omit<OrderProperty, 'loans'>>,
  name: FieldPath<Omit<OrderProperty, 'loans'>>,
  label: string,
}

export const PropertyDatePicker: FC<PropertyDatePickerProps> = ({
  control,
  name,
  label,
}) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState: { error } }) => (
      <DatePicker
        label={label}
        {...field}
        disableToolbar={false}
        value={field.value as string}
        InputLabelProps={{ shrink: field.value !== null && field.value!.toString().length > 0 }}
        error={!!error}
      />
    )}
  />
);
